import { UtilityService } from '../../shared/standalone-packages/ecap3/core';
import { parsePhoneNumber } from 'libphonenumber-js';
import { forEach as _forEach, indexOf as _indexOf, isEmpty, startsWith } from 'lodash-es';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';

export const defaultRoles: any = ['appuser', 'anonymous'];
const ecapCorGuidGeneratorService = new UtilityService();

export class UpdateUserBuisnessCommand {
    ItemId?: string;
    DisplayName?: string;
    PhoneNumber?: string;
    Email: string;
    Active: boolean;
    Roles?: string[];
    UserId: string;
    TwoFactorEnabled: boolean;
    CountryCode?: string;
    Tags?: string[];
    Language: string;
    Salutation?: string;
    FirstName?: string;
    LastName?: string;
    PersonaEnabled?: boolean;
    Sex?: string;
    Designation?: string;
    PersonInfo?: any;

    constructor(userInfo?, updatePersonInfoByDefaultInfo?) {
        userInfo = userInfo || {};
        this.FirstName = (userInfo && userInfo.FirstName) || '';
        this.LastName = (userInfo && userInfo.LastName) || '';
        this.DisplayName = (userInfo && userInfo.DisplayName) || `${this.FirstName} ${this.LastName}`;
        this.Email = (userInfo && userInfo.Email && userInfo.Email.toLowerCase()) || '';
        this.Active = userInfo && userInfo.Active;
        this.Roles = userInfo && userInfo.Roles && this.getUpdatedUserRoles(userInfo.Roles);
        this.UserId = (userInfo && userInfo.UserId) || (userInfo && userInfo.ItemId);
        this.TwoFactorEnabled = this.getTwoFactorStatus(userInfo.TwoFactorEnabled);
        this.PhoneNumber = (userInfo && this.getValidPhoneNumber(userInfo.PhoneNumber)) || '';
        this.CountryCode =
            (userInfo && userInfo.CountryCode) || (this.PhoneNumber && this.getCountryCode(this.PhoneNumber)) || '';
        this.Language = (userInfo && userInfo.Language) || 'en-US';
        this.Salutation = (userInfo && userInfo.Salutation) || '';
        this.PersonaEnabled = (userInfo && userInfo.PersonaEnabled) || false;
        this.ItemId = (userInfo && userInfo.ItemId) || '';
        this.Sex = (userInfo && userInfo.Sex) || '';

        if (updatePersonInfoByDefaultInfo) {
            this.PersonInfo = userInfo && userInfo.PersonInfo;
        } else {
            this.PersonInfo = {
                FirstName: (userInfo && userInfo.FirstName) || '',
                LastName: (userInfo && userInfo.LastName) || '',
                DisplayName: (userInfo && userInfo.DisplayName) || `${this.FirstName} ${this.LastName}`,
                Email: (userInfo && userInfo.Email && userInfo.Email.toLowerCase()) || '',
                PhoneNumber: this.PhoneNumber || '',
                Salutation: this.Salutation || ''
            };
        }
        this.PersonInfo['Sex'] = (userInfo && userInfo.Sex) || 'MALE';
        this.PersonInfo['DateOfBirth'] = userInfo && userInfo.DateOfBirth;
        this.PersonInfo['Nationality'] = (userInfo && userInfo.Nationality) || '';
        this.PersonInfo['ProfileImageId'] = (userInfo && userInfo.ProfileImageId) || '';

        // Address
        this.PersonInfo['CompanyName'] = userInfo?.CompanyName ?? SCConfig.IpexDefaultAddress.CompanyName;
        this.PersonInfo['Street'] = userInfo?.Street ?? SCConfig.IpexDefaultAddress.Street;
        this.PersonInfo['StreetNumber'] = userInfo?.StreetNumber ?? SCConfig.IpexDefaultAddress?.StreetNumber;
        this.PersonInfo['PostalCode'] = userInfo?.PostalCode ?? SCConfig.IpexDefaultAddress.ZipCode;
        this.PersonInfo['City'] = userInfo?.City ?? SCConfig.IpexDefaultAddress.City;
    }

    getValidPhoneNumber(phoneNumber: string): string | null {
        if (!phoneNumber) {
            return null;
        }
        if (startsWith(phoneNumber, '+')) {
            return phoneNumber;
        }
        return `+${phoneNumber}`;
    }
    getUpdatedUserRoles(userRoles) {
        if (!userRoles) {
            userRoles = [];
        }
        //debugger
        _forEach(defaultRoles, role => {
            if (_indexOf(userRoles, role) === -1) {
                userRoles.push(role);
            }
        });
        return userRoles;
    }
    getCountryCode(phoneNumber) {
        try {
            const phoneNumberInfo = phoneNumber ? parsePhoneNumber(phoneNumber) : null;
            return phoneNumberInfo && phoneNumberInfo.country;
        } catch (ex) {
            return null;
        }
    }
    getTwoFactorStatus(twofactor) {
        if (twofactor === undefined || twofactor === null) {
            return true;
        }
        return twofactor !== false;
    }
}
export class CreateUserBuisnessCommand {
    PersonaEnabled?: boolean;
    Password?: string;
    UserName?: string;
    Email: string;
    ItemId: string;
    DisplayName?: string;
    PhoneNumber?: string;
    ProfileImageUrl?: string;
    SignUp?: boolean;
    DefaultPassword?: string;
    RegisteredBy?: number;
    Roles: string[];
    CountryCode?: string;
    TwoFactorEnabled?: boolean;
    Tags?: string[];
    MailPurpose?: string;
    FirstName?: string;
    LastName?: string;
    Salutation?: string;
    Language?: string;
    HostDomain?: string;
    CopyEmailTo?: string[];
    AutoExpire?: boolean;
    ExpireOn?: Date;
    Designation?: string;
    Sex?: string;
    PersonInfo?: any;

    constructor(userInfo?, updatePersonInfoByDefaultInfo?) {
        userInfo = userInfo || {};
        this.FirstName = (userInfo && userInfo.FirstName) || '';
        this.LastName = (userInfo && userInfo.LastName) || '';
        this.DisplayName =
            (userInfo && userInfo.DisplayName) ||
            (this.FirstName || this.LastName ? `${this.FirstName} ${this.LastName}` : '');
        this.Email = (userInfo && userInfo.Email && userInfo.Email.toLowerCase()) || '';
        this.Roles = userInfo && userInfo.Roles && this.getUpdatedUserRoles(userInfo.Roles);
        this.TwoFactorEnabled = this.getTwoFactorStatus(userInfo.TwoFactorEnabled);
        this.PhoneNumber = (userInfo && userInfo.PhoneNumber) || '';
        this.CountryCode =
            (userInfo && userInfo.CountryCode) || (this.PhoneNumber && this.getCountryCode(this.PhoneNumber)) || '';
        this.Language = (userInfo && userInfo.Language) || 'en-US';
        this.Salutation = (userInfo && userInfo.Salutation) || '';
        this.PersonaEnabled = (userInfo && userInfo.PersonaEnabled) || false;
        this.UserName = (userInfo && userInfo.UserName) || (userInfo && userInfo.Email);
        this.ItemId = (userInfo && userInfo.ItemId) || ecapCorGuidGeneratorService.getNewGuid();
        this.Password = (userInfo && userInfo.Password) || '';
        this.MailPurpose = (userInfo && userInfo.MailPurpose) || '';
        this.DefaultPassword = (userInfo && userInfo.DefaultPassword) || '';
        this.HostDomain = (userInfo && userInfo.HostDomain) || '';
        this.RegisteredBy = (userInfo && userInfo.RegisteredBy) || 1;
        this.Sex = (userInfo && userInfo.Sex) || 'MALE';
        if (updatePersonInfoByDefaultInfo) {
            this.PersonInfo = userInfo && userInfo.PersonInfo;
        } else {
            this.PersonInfo = {
                FirstName: (userInfo && userInfo.FirstName) || '',
                LastName: (userInfo && userInfo.LastName) || '',
                DisplayName: (userInfo && userInfo.DisplayName) || `${this.FirstName} ${this.LastName}`,
                Email: (userInfo && userInfo.Email && userInfo.Email.toLowerCase()) || '',
                PhoneNumber: this.PhoneNumber || '',
                Salutation: this.Salutation || ''
            };
        }
        this.PersonInfo['ProfileImageId'] = (userInfo && userInfo.ProfileImageId) || '';
        this.PersonInfo['Sex'] = (userInfo && userInfo.Sex) || 'MALE';
        this.PersonInfo['DateOfBirth'] = userInfo && userInfo.DateOfBirth;
        this.PersonInfo['Nationality'] = (userInfo && userInfo.Nationality) || '';

        // Address
        this.PersonInfo['CompanyName'] = userInfo?.CompanyName ?? SCConfig.IpexDefaultAddress.CompanyName;
        this.PersonInfo['Street'] = userInfo?.Street ?? SCConfig.IpexDefaultAddress.Street;
        this.PersonInfo['StreetNumber'] = userInfo?.StreetNumber ?? SCConfig.IpexDefaultAddress?.StreetNumber;
        this.PersonInfo['PostalCode'] = userInfo?.PostalCode ?? SCConfig.IpexDefaultAddress.ZipCode;
        this.PersonInfo['City'] = userInfo?.City ?? SCConfig.IpexDefaultAddress.City;
    }

    getUpdatedUserRoles(userRoles) {
        if (!userRoles) {
            userRoles = [];
        }
        _forEach(defaultRoles, role => {
            if (_indexOf(userRoles, role) !== -1) {
                userRoles.push(role);
            }
        });
        return userRoles;
    }

    getCountryCode(phoneNumber) {
        try {
            const phoneNumberInfo = phoneNumber ? parsePhoneNumber(phoneNumber) : null;
            return phoneNumberInfo && phoneNumberInfo.country;
        } catch (ex) {
            return null;
        }
    }
    getTwoFactorStatus(twofactor) {
        if (twofactor === undefined || twofactor === null) {
            return true;
        }
        return twofactor !== false;
    }
}

export class Person {
    ItemId: string;
    DisplayName: string;
    Email: string;
    ProfileImage: string;
    ProfileImageId: string;
    UserIdentifier: string;
    Roles: string[];
    CreatedBy: string;
    Active: boolean;
}

export class PersonForUser extends Person {
    UserId: string;
    Salutation: string;
    FirstName: string;
    LastName: string;
    Sex: string;
    DateOfBirth: any;
    Nationality: string;
    PhoneNumber: string;
    Tags: string[];
    Language: string;
}

export class EcapUser {
    AccountNumber: any;
    AddressLine1: string;
    AddressLine2: string;
    AnnualSalary: number;
    AnnualSavings: number;
    City: string;
    ColorCode: string;
    CompanyName: string;
    ContactEmails: string[];
    ContactEmailsPlainText: string;
    ContactPhoneNumbers: string[];
    ContactPhoneNumbersPlainText: any;
    Countires: string[];
    Country: string;
    CreatedBy: string;
    Currency: string;
    CurrentSavings: number;
    CustomerId: string;
    DateOfBirth: Date | string;
    Designation: string;
    DisplayName: string;
    EligibleForServiceCheck: boolean;
    Email: string;
    FATCADescription: any;
    FirstName: string;
    FirstTimeLogIn: boolean;
    InflationRate: number;
    Interests: string[];
    IsFATCACompliant: boolean;
    IsPoliticallyExposedPerson: boolean;
    IsPrivacyPolicyAgreement: boolean;
    IsSuccess: boolean;
    IsVerified: boolean;
    ItemId: string;
    Language: string;
    LastLogInTime: Date | string;
    LastName: string;
    LifeExpectancy: number;
    LogInCount: number;
    LogInError: string[] | string | boolean;
    MaritalStatus: boolean;
    MarketName: string;
    MarriedSince: Date | string;
    MiddleName: string;
    Nationality: string;
    NetIncome: number;
    NetWorth: number;
    NextUrl: string;
    OfficeCountryCode: string;
    OfficialPhoneNumber: string | number;
    Organization: string;
    OrganizationId: string;
    PEPDetails: any;
    PersonData: PersonInformation;
    PersonId: string;
    PersonaEnabled: false;
    PhoneNumber: string;
    PostalCode: any;
    ProfileImage: any;
    ProfileImageId: string;
    ProfileImageUrl: any;
    ProposedUserId: any;
    RetirementAge: number;
    Roles: string[];
    Salutation: string;
    Sex: string;
    ShortBio: string;
    Skills: string[];
    SocialSecurityIncome: number;
    State: any;
    StatusCode: number;
    Street: any;
    Tags: string[];
    UserId: string;
    UserName: string;
}

export class PersonInformationOld {
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Email: string;
    Roles: string[];
    TwoFactorEnabled: boolean;
    CountryCode: string;
    Tags: string[];
    MotherTongue: string;
    Salutation: string;
    UserName: string;
    Password: string;
    ItemId: string;
    MailPurpose: string;
    CopyEmailTo: string[];
    DefaultPassword: string;
    HostDomain: string;
    RegisteredBy?: number;
    PersonInfo;
    PhoneNumber: string;
    ProfileImageUrl: string;
    SignUp: boolean;
    PersonaEnabled: boolean;
    Title: string;
    DateOfBirth: Date;
    CustomerId: string;
    MarketName: string;
    Sex: string;
    Nationality: string;
    Designation: string;
    Street: string;
    PostalCode: string;
    State: string;
    Country: string;
    City: string;
    PostNominalTitle: string;
    ManagerNr: string;
    ClientStatus: string;
    ProfileImageId: string;
    OtherLanguage: string[];
    OrganizationNames: string[];
    UserId: string;
    Language: string;
    Gender: string;
    constructor(formValue?) {
        if (!isEmpty(formValue)) {
            this.Salutation = formValue['Salutation'];
            this.FirstName = formValue['FirstName'];
            this.LastName = formValue['LastName'];
            this.DisplayName = formValue['DisplayName'];
            this.Gender = formValue['Gender'];
            this.DateOfBirth = formValue['DateOfBirth']; // date
            this.Nationality = formValue['Nationality'];
            this.MotherTongue = formValue['MotherTongue'];
            this.OtherLanguage = formValue['OtherLanguage'];
            this.Email = formValue['Email'];
        }
    }
}

export class PersonInformation {
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Email: string;
    Roles: string[];
    CountryCode: string;
    Tags: string[];
    Salutation: string;
    UserName: string;
    Password: string;
    ItemId: string;
    PersonInfo;
    PhoneNumber: string;
    ProfileImageUrl: string;
    DateOfBirth: Date;
    Sex: string;
    ProfileImageId: string;
    Gender: string;
    Active: boolean;
    constructor(formValue?) {
        if (!isEmpty(formValue)) {
            this.Salutation = formValue['Salutation'];
            this.FirstName = formValue['FirstName'];
            this.LastName = formValue['LastName'];
            this.DisplayName = formValue['DisplayName'];
            this.Gender = formValue['Gender'];
            this.DateOfBirth = formValue['DateOfBirth']; // date
            this.Email = formValue['Email'];
        }
    }
}
